const SCROLL_POPUP_TRIGGER_CLASSNAME = 'scroll-popup-trigger';
const SCROLL_POPUP_OFFSCREEN_CLASSNAME = 'scroll-popup-trigger--offscreen';
const POPUP_DISMISSED_KEY = 'guide_popup_dismissed';

function dismissPopup(popupElement) {
  popupElement.remove();
  try {
    sessionStorage.setItem(POPUP_DISMISSED_KEY, '1');
  } catch {}
}

function onIntersection(elements, observer) {
  elements.forEach((element) => {
    if (!element.isIntersecting) {
      element.target.classList.add(SCROLL_POPUP_OFFSCREEN_CLASSNAME);
      return;
    }

    const elementTarget = element.target;
    observer.unobserve(elementTarget);

    if (!elementTarget.classList.contains(SCROLL_POPUP_OFFSCREEN_CLASSNAME)) return;
    elementTarget.classList.remove(SCROLL_POPUP_OFFSCREEN_CLASSNAME);

    const headerElement = document.querySelector('.header-wrapper');
    if (!headerElement) return;

    const popupElement = document.createElement('div');
    popupElement.id = 'popup';
    popupElement.setAttribute('role', 'dialog');
    popupElement.setAttribute('aria-modal', 'true');
    popupElement.setAttribute('aria-label', 'Subscribe for the Home Sanctuary Guide');

    const popupContainerElement = document.createElement('div');
    popupContainerElement.classList.add('popup-container');

    const popupGuidePreviewElement = document.createElement('img');
    popupGuidePreviewElement.classList.add('popup-image');
    popupGuidePreviewElement.alt = 'Home Sanctuary Guide preview';

    const popupButtonsElement = document.createElement('div');
    popupButtonsElement.classList.add('popup-container-buttons');

    const popupSignUpButtonElement = document.createElement('button');
    popupSignUpButtonElement.classList.add('button', 'button--secondary');
    popupSignUpButtonElement.textContent = 'Subscribe for Guide';

    const popupCloseButtonElement = document.createElement('button');
    popupCloseButtonElement.classList.add('button', 'button--primary');
    popupCloseButtonElement.textContent = 'Close';
    popupCloseButtonElement.setAttribute('aria-label', 'Close popup');

    popupButtonsElement.appendChild(popupSignUpButtonElement);
    popupButtonsElement.appendChild(popupCloseButtonElement);
    popupContainerElement.appendChild(popupGuidePreviewElement);
    popupContainerElement.appendChild(popupButtonsElement);

    popupCloseButtonElement.onclick = () => dismissPopup(popupElement);

    popupSignUpButtonElement.onclick = () => {
      dismissPopup(popupElement);
      const newsletterForm = document.querySelector('[id^="NewsletterForm--"]');
      if (newsletterForm) {
        newsletterForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        newsletterForm.focus();
      }
    };

    document.addEventListener('keydown', function handleEscape(e) {
      if (e.key === 'Escape' && document.getElementById('popup')) {
        dismissPopup(popupElement);
        document.removeEventListener('keydown', handleEscape);
      }
    });

    popupElement.addEventListener('click', (e) => {
      if (e.target === popupElement) dismissPopup(popupElement);
    });

    popupGuidePreviewElement.onload = () => {
      popupElement.appendChild(popupContainerElement);
      headerElement.insertBefore(popupElement, headerElement.firstElementChild);
      popupCloseButtonElement.focus();
    };

    popupGuidePreviewElement.onerror = () => {
      popupElement.appendChild(popupContainerElement);
      popupGuidePreviewElement.remove();
      headerElement.insertBefore(popupElement, headerElement.firstElementChild);
    };

    popupGuidePreviewElement.src = 'https://cdn.shopify.com/s/files/1/0793/2847/7469/files/Guide.jpg?v=1696605787';
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  try {
    if (sessionStorage.getItem(POPUP_DISMISSED_KEY)) return;
  } catch {}

  const url = new URL(window.location.href);
  if (url.searchParams.get('customer_posted') === 'true') return;

  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_POPUP_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-popup-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
